const texts = {
  en: {
    reply: 'Reply now',
    view: 'View messages',
    dismiss: 'Dismiss',
    close: 'Close',
    title: (count: number) => `You've got ${count} new messages`,
    more: (count: number, creator: boolean) =>
      `Messages from ${count} other ${creator ? 'brands' : 'creators'}`,
    now: 'Just now',
    minutes: (n: number) => `${n} min ago`,
    hours: (n: number) => `${n} ${n === 1 ? 'hour' : 'hours'} ago`,
    days: (n: number) => `${n} ${n === 1 ? 'day' : 'days'} ago`
  },
  zh: {
    reply: '立即回复',
    view: '查看消息',
    dismiss: '忽略',
    close: '关闭',
    title: (count: number) => `你有 ${count} 条新消息`,
    more: (count: number, creator: boolean) =>
      `还有 ${count} 个${creator ? '品牌' : '达人'}的消息`,
    now: '刚刚',
    minutes: (n: number) => `${n} 分钟前`,
    hours: (n: number) => `${n} 小时前`,
    days: (n: number) => `${n} 天前`
  },
  pt: {
    reply: 'Responder agora',
    view: 'Ver mensagens',
    dismiss: 'Dispensar',
    close: 'Fechar',
    title: (count: number) => `Você tem ${count} novas mensagens`,
    more: (count: number, creator: boolean) =>
      `Mensagens de ${count} ${creator ? 'outras marcas' : 'outros criadores'}`,
    now: 'Agora',
    minutes: (n: number) => `Há ${n} min`,
    hours: (n: number) => `Há ${n} ${n === 1 ? 'hora' : 'horas'}`,
    days: (n: number) => `Há ${n} ${n === 1 ? 'dia' : 'dias'}`
  },
  ja: {
    reply: '今すぐ返信',
    view: 'メッセージを見る',
    dismiss: '閉じる',
    close: '閉じる',
    title: (count: number) => `${count} 件の新しいメッセージがあります`,
    more: (count: number, creator: boolean) =>
      `他の ${count} ${creator ? 'ブランド' : 'クリエイター'}からのメッセージ`,
    now: 'たった今',
    minutes: (n: number) => `${n} 分前`,
    hours: (n: number) => `${n} 時間前`,
    days: (n: number) => `${n} 日前`
  }
};

export function getTimToastText(language: string) {
  return texts[language.split('-')[0] as keyof typeof texts] || texts.en;
}

export function formatTimToastTime(
  sentAt: number,
  now: number,
  language: string
) {
  const text = getTimToastText(language);
  const seconds = Math.max(0, Math.floor((now - sentAt) / 1000));
  if (seconds < 60) return text.now;
  if (seconds < 3600) return text.minutes(Math.floor(seconds / 60));
  if (seconds < 86400) return text.hours(Math.floor(seconds / 3600));
  if (seconds < 604800) return text.days(Math.floor(seconds / 86400));
  return new Intl.DateTimeFormat(language || 'en-US', {
    month: 'short',
    day: 'numeric',
    ...(new Date(sentAt).getFullYear() !== new Date(now).getFullYear()
      ? { year: 'numeric' as const }
      : {})
  }).format(sentAt);
}
